/** Obsah FAQ na landing page — sdílené pro UI a JSON-LD schema. */
export const LANDING_FAQS = [
  {
    id: 1,
    q: "Je Aidvisora CRM pro finanční poradce?",
    a: "Ano. Aidvisora je pracovní systém pro poradce a týmy: karta klienta, smlouvy, dokumenty, úkoly, kalendář, požadavky z klientské zóny a přehled obchodů.",
  },
  {
    id: 2,
    q: "Umí Aidvisora pracovat se smlouvami a PDF?",
    a: "Podle tarifu a nastavení pomáhá s nahráním podkladů, čtením PDF a AI Review smluv — interním souhrnem polí ke kontrole. Výstup není rada klientovi.",
  },
  {
    id: 3,
    q: "Jak funguje klientská zóna?",
    a: "Klient má vlastní prostor pro dokumenty, zprávy a požadavky. Poradce v CRM hned vidí, ke komu podklad patří.",
  },
  {
    id: 4,
    q: "Je Aidvisora vhodná pro tým?",
    a: "Ano. Tarif Team přidává role, týmový přehled, produkci a manažerské reporty — poradce, asistent i manažer pracují ve stejném systému.",
  },
  {
    id: 5,
    q: "Nahrazuje AI finančního poradce?",
    a: "Ne. AI připravuje interní podklady pro poradce. Finální posouzení, komunikaci s klientem a odpovědnost má vždy poradce.",
  },
  {
    id: 6,
    q: "Kde jsou uložená data?",
    a: "U evropských poskytovatelů. Prostory firem jsou oddělené, přístup řídí role a citlivé akce jsou dohledatelné.",
  },
  {
    id: 7,
    q: "Jaké Google napojení je v tarifech?",
    a: "Google Kalendář, Gmail a Google Disk podle tarifu a nastavení účtu. Přesný rozsah ověřte v demu nebo v nastavení.",
  },
  {
    id: 8,
    q: "Umí Aidvisora importovat existující data?",
    a: "Ano, z tabulek nebo jiných systémů — podle toho, jak jsou data připravená. Rozsah domluvíme při onboardingu.",
  },
  {
    id: 9,
    q: "Jak funguje zkušební verze?",
    a: "14 dní v tarifu Pro, bez platební karty. Účet můžete kdykoli nechat běžet dál nebo ukončit.",
  },
  {
    id: 10,
    q: "Co se stane s daty po ukončení?",
    a: "Před ukončením vyřešíte export podle nastavení účtu a smluv. Po smazání účtu data mažeme podle retenčních pravidel.",
  },
  {
    id: 11,
    q: "Je Aidvisora u ČNB registrovaná jako zprostředkovatel?",
    a: "Ne. Aidvisora je technologická platforma pro interní práci poradce. Nejsme finanční zprostředkovatel a klientům neposkytujeme poradenství.",
  },
  {
    id: 12,
    q: "Platí se za každého poradce zvlášť?",
    a: "Ceník je za organizaci a tarif. U větších týmů domluvíme počet uživatelů a rolí individuálně.",
  },
] as const;

/** Doplňkové FAQ pouze na `/tarify` (DPH, Stripe fakturace). */
export const TARIFY_FAQ_EXTRA = [
  {
    id: 901,
    q: "Jak je to s DPH?",
    a: "Nejsme plátci DPH. Uvedené ceny jsou konečné. Platby a faktury spravuje Stripe.",
  },
  {
    id: 902,
    q: "Kde spravuji platební kartu a faktury?",
    a: "V aplikaci v Nastavení → záložka Fakturace a tarif (/portal/nastaveni). Odtud se dostanete do Stripe portálu pro kartu, faktury a změnu tarifu.",
  },
] as const;

/** Pořadí otázek na `/tarify` (id z {@link LANDING_FAQS}). */
export const LANDING_FAQ_ORDER_TARIFY: readonly number[] = [
  9, 12, 7, 5, 3, 1, 2, 4, 6, 8, 10, 11,
];

export function landingFaqsInTarifyOrder(): readonly (typeof LANDING_FAQS)[number][] {
  const byId = Object.fromEntries(LANDING_FAQS.map((item) => [item.id, item])) as Record<
    number,
    (typeof LANDING_FAQS)[number]
  >;
  return LANDING_FAQ_ORDER_TARIFY.map((id) => {
    const row = byId[id];
    if (!row) throw new Error(`LANDING_FAQ_ORDER_TARIFY: missing FAQ id ${id}`);
    return row;
  });
}

/** FAQ viditelné na `/tarify` — pro UI i JSON-LD. */
export function tarifyVisibleFaqs(): readonly { q: string; a: string }[] {
  return [...landingFaqsInTarifyOrder(), ...TARIFY_FAQ_EXTRA].map(({ q, a }) => ({ q, a }));
}
